import type { xlncaContentEN } from "../en/xlnca-content";

export const xlncaContentES: typeof xlncaContentEN = {
  purpose: {
    title: "Propósito",
    description:
      "Las organizaciones dependen de sus procesos para crear valor. Mejorarlos requiere probar nuevas formas de trabajar, coordinar a los participantes, recopilar información y dar seguimiento a los resultados. Sin embargo, el trabajo en torno a un proceso o piloto puede fragmentarse entre hojas de cálculo, documentos, correos electrónicos, herramientas de colaboración, firmas y otros sistemas desconectados.",
    highlight: "XLNC-A reúne ese trabajo en un solo lugar.",
    summary:
      "XLNC-A convierte los procesos de negocio en flujos de trabajo digitales configurables que conectan personas, información, acciones, permisos y salidas en un solo lugar.",
  },
  overview: {
    title: "¿Qué es XLNC-A?",
    paragraphs: [
      "XLNC-A es una plataforma configurable que lleva los flujos de trabajo a un entorno digital y los adapta a las necesidades operativas de cada organización. En lugar de construir cada solución desde cero, las organizaciones configuran Value Streams, Forms, Questions, permisos, usuarios, identidad de marca y Outputs sobre una base flexible. Cada organización opera a través de su propio Tenant Portal, configurado para sus procesos, usuarios, reglas de acceso, identidad de marca y requisitos.",
      "Este enfoque basado en la configuración permite que XLNC-A admita distintos procesos y casos de uso, manteniendo una experiencia digital consistente.",
    ],
  },
  flow: {
    title: "Del proceso al flujo digital",
    description:
      "En GBCI Group, la Excelencia Operacional consiste en encontrar oportunidades para mejorar el trabajo y probar esas mejoras mediante pilotos. XLNC-A proporciona la infraestructura para convertir procesos y pilotos en flujos de trabajo conectados. En lugar de trasladar información entre herramientas desconectadas, los participantes siguen un flujo estructurado en el que cada paso, Form, acción, permiso y Output está vinculado.",
    steps: ["Diseñar", "Configurar", "Ejecutar", "Dar seguimiento", "Evaluar"],
  },
  work: {
    title: "Trabaja donde ocurre el proceso",
    paragraphs: [
      "XLNC-A está disponible en web y móvil, lo que permite a los usuarios interactuar con sus flujos de trabajo en el entorno que se adapta a su función. La experiencia web permite configurar y gestionar flujos de trabajo, mientras que XLNCA Mobile extiende las capacidades clave más allá del escritorio.",
      "Desde la administración en oficina hasta el trabajo de campo, los usuarios pueden acceder a los procesos asignados, completar Forms, proporcionar información y mantener el trabajo en marcha sin depender de un solo entorno.",
    ],
  },
  waste: {
    title: "Diseñado para reducir el desperdicio",
    description:
      "XLNCA parte de una idea sencilla: la tecnología de apoyo no debe convertirse en otra fuente de desperdicio.",
    introduction:
      "Al conectar información, personas, Forms, permisos, acciones y Outputs dentro de un flujo de trabajo configurable, XLNC-A ayuda a las organizaciones a:",
    benefits: [
      "Reducir los pasos manuales.",
      "Minimizar la dependencia de herramientas desconectadas.",
      "Mantener la información centralizada y vinculada al proceso.",
      "Guiar a los participantes a través del flujo de trabajo correcto.",
      "Mejorar la visibilidad durante la ejecución.",
      "Estandarizar la ejecución de los procesos.",
      "Adaptar los flujos de trabajo digitales a medida que cambian las necesidades del negocio.",
      "Ejecutar pilotos con mayor consistencia.",
    ],
  },
  adapt: {
    title: "Creado para adaptarse",
    description:
      "La arquitectura configurable de XLNC-A permite a las organizaciones crear experiencias digitales en torno a sus procesos, en lugar de forzarlos a encajar en una aplicación fija. Los Value Streams, Forms, Questions, permisos, navegación, Outputs, identidad de marca y modelos de acceso se pueden configurar para cumplir con los requisitos operativos.",
  },
  tryIt: {
    title: "Prueba XLNCA",
    description:
      "Descubre cómo un flujo de trabajo digital configurable puede simplificar la forma en que tu organización ejecuta procesos y pilotos.",
    closing:
      "Reduce el desperdicio. Conecta el proceso. Haz avanzar el trabajo con XLNCA.",
    contact: "Contáctanos",
  },
};
